export const FETCH_ALL_FAVORITES_REQUEST = "fetch/all/favorites/request";
export const FETCH_ALL_FAVORITES_SUCCESS = "fetch/all/favorites/success";
export const FETCH_ALL_FAVORITES_FAILURE = "fetch/all/favorites/failure";

export const ADD_FAVORITES_REQUEST = "add/favorites/request";
export const ADD_FAVORITES_SUCCESS = "add/favorites/success";
export const ADD_FAVORITES_FAILURE = "add/favorites/failure";

export const DELETE_FAVORITES_REQUEST = "delete/favorites/request";
export const DELETE_FAVORITES_SUCCESS = "delete/favorites/success";
export const DELETE_FAVORITES_FAILURE = "delete/favorites/failure";
